// extracted by mini-css-extract-plugin
module.exports = {"blogLogo":"blogs_blogLogo__E3Hxv"};